var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "",
        width: "920px",
        "close-on-click-modal": false,
        "show-close": true,
        "custom-class": "jd-sku-detail-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "sku-detail-page",
        },
        [
          _c(
            "div",
            { staticClass: "section" },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("基础信息")]),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "kv-row", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("商品编号：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(_vm._s(_vm.detail.skuId || "--")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("主商品ID：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(_vm._s(_vm.detail.spuId || "--")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [
                        _vm._v("是否主商品："),
                      ]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(_vm._s(_vm.detail.isMain ? "是" : "否")),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "kv-row", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("商品名称：")]),
                      _c("span", { staticClass: "v v-wrap" }, [
                        _vm._v(_vm._s(_vm.detail.skuName || "--")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("品牌名称：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(_vm._s(_vm.detail.brandName || "--")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("规格参数：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(_vm._s(_vm.detail.seoModel || "--")),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "kv-row", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("商品类型：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.skuType === 1
                              ? "通用"
                              : _vm.detail.skuType != null
                              ? _vm.detail.skuType
                              : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("是否自营：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.selfSellType === 1
                              ? "自营"
                              : _vm.detail.selfSellType != null
                              ? _vm.detail.selfSellType
                              : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("上柜状态：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.skuState === 1
                              ? "有效"
                              : _vm.detail.skuState != null
                              ? _vm.detail.skuState
                              : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("分类与价格"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "line-row" }, [
                _c("span", { staticClass: "k" }, [
                  _vm._v("京东商城展示分类："),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "v" }, [
                  _vm._v(_vm._s(_vm.detail.jdMallDisplayCategory || "--")),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "kv-row mt12", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [
                        _vm._v("结算价（元）："),
                      ]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(_vm._s(_vm.formatMoney(_vm.detail.sellPrice))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [
                        _vm._v("建议销售价（元）："),
                      ]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(_vm._s(_vm.formatMoney(_vm.detail.retail))),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [
                        _vm._v("调价后售价（元）："),
                      ]),
                      _vm._v(" "),
                      _vm.detail.salePrice != null
                        ? _c(
                            "span",
                            { class: _vm.getPriceClass() },
                            [
                              _vm.getPriceDiff() !== 0
                                ? _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        placement: "top",
                                        enterable: false,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "price-tooltip",
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              "售价：¥" +
                                                _vm._s(_vm.detail.salePrice)
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              "建议销售价：¥" +
                                                _vm._s(_vm.detail.retail)
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              style:
                                                _vm.getPriceDiff() > 0
                                                  ? "color:#f56c6c"
                                                  : "color:#409EFF",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.getPriceDiff() > 0
                                                      ? "上浮"
                                                      : "下浮"
                                                  ) +
                                                  "：\n                    " +
                                                  _vm._s(
                                                    _vm.getPriceDiff() > 0
                                                      ? "+"
                                                      : ""
                                                  ) +
                                                  _vm._s(_vm.getAdjustRatio()) +
                                                  "%\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "price-wrap" },
                                        [
                                          _vm.getPriceDiff() > 0
                                            ? _c(
                                                "span",
                                                { staticClass: "arrow" },
                                                [_vm._v("↑")]
                                              )
                                            : _vm.getPriceDiff() < 0
                                            ? _c(
                                                "span",
                                                { staticClass: "arrow" },
                                                [_vm._v("↓")]
                                              )
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.formatMoney(
                                                  _vm.detail.salePrice
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c("span", { staticClass: "price-wrap" }, [
                                    _vm.getPriceDiff() > 0
                                      ? _c("span", { staticClass: "arrow" }, [
                                          _vm._v("↑"),
                                        ])
                                      : _vm.getPriceDiff() < 0
                                      ? _c("span", { staticClass: "arrow" }, [
                                          _vm._v("↓"),
                                        ])
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.formatMoney(_vm.detail.salePrice)
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                            ],
                            1
                          )
                        : _c("span", { staticClass: "v" }, [_vm._v("--")]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "kv-row", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [
                        _vm._v("最低起购量："),
                      ]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.lowestBuy != null
                              ? _vm.detail.lowestBuy
                              : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [
                        _vm._v("京东侧税收分类编码："),
                      ]),
                      _c("span", { staticClass: "v v-wrap" }, [
                        _vm._v(_vm._s(_vm.detail.taxCode || "--")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("税率：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.taxRatePercentage != null
                              ? _vm.detail.taxRatePercentage + "%"
                              : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "kv-row", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("售卖单位：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(_vm._s(_vm.detail.saleUnit || "--")),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "section" }, [
            _c("div", { staticClass: "section-title" }, [_vm._v("图片信息")]),
            _vm._v(" "),
            _c("div", { staticClass: "img-block" }, [
              _c("div", { staticClass: "img-label" }, [_vm._v("商品主图")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "img-main" },
                [
                  _vm.detail.imagePath || _vm.detail.defaultImagePath
                    ? _c("el-image", {
                        staticClass: "img-main-el",
                        attrs: {
                          src:
                            _vm.detail.imagePath || _vm.detail.defaultImagePath,
                          "preview-src-list": _vm.getPreviewList(),
                          fit: "cover",
                        },
                      })
                    : _c("div", { staticClass: "img-ph" }, [_vm._v("暂无")]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "img-block mt16" }, [
              _c("div", { staticClass: "img-label" }, [_vm._v("商品图片列表")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "img-list" },
                _vm._l(_vm.detail.imageList || [], function (item, idx) {
                  return _c(
                    "div",
                    { key: idx, staticClass: "img-item" },
                    [
                      item.shortPath
                        ? _c("el-image", {
                            staticClass: "img-item-el",
                            attrs: {
                              src: item.shortPath,
                              "preview-src-list": _vm.getPreviewList(),
                              fit: "cover",
                            },
                          })
                        : _c("div", { staticClass: "img-ph" }, [
                            _vm._v("暂无"),
                          ]),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section" },
            [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("规格与物流"),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "kv-row", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("重量：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.weight != null &&
                              _vm.detail.weight !== ""
                              ? _vm.detail.weight
                              : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("商品颜色：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(_vm._s(_vm.detail.color || "--")),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("商品尺寸：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(_vm._s(_vm.detail.size || "--")),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "kv-row", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("商品-长：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.length != null ? _vm.detail.length : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("商品-宽：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.width != null ? _vm.detail.width : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("商品-高：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.height != null ? _vm.detail.height : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "kv-row", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("容量：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.capacity != null
                              ? _vm.detail.capacity
                              : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("货期：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.deliveryTime != null
                              ? _vm.detail.deliveryTime
                              : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("产地：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(_vm._s(_vm.detail.productArea || "--")),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "kv-row", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("配送类型：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.logisticsType === 1
                              ? "京东配送"
                              : _vm.detail.logisticsType != null
                              ? _vm.detail.logisticsType
                              : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [
                        _vm._v("节能商品类型："),
                      ]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(
                          _vm._s(
                            _vm.detail.saveEnergyType === 0
                              ? "非节能"
                              : _vm.detail.saveEnergyType != null
                              ? _vm.detail.saveEnergyType
                              : "--"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "kv" }, [
                      _c("span", { staticClass: "k" }, [_vm._v("质保说明：")]),
                      _c("span", { staticClass: "v" }, [
                        _vm._v(_vm._s(_vm.detail.warrantDesc || "--")),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }